function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Loader } from '../Loader';
import { BaseButton } from './BaseButton';
const LoaderContainer = styled.div`
  label: JMT-General-LoaderContainer;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
export const Button = ({
  children,
  showLoader,
  onClick,
  template,
  disabled,
  ...props
}) => {
  const [buttonSize, setButtonSize] = useState({
    width: 0,
    height: 0
  });
  const ref = useRef(null);
  const accumulatedProps = { ...props,
    ...(() => !showLoader ? {} : Object.keys(buttonSize).reduce((acc, val) => {
      if (buttonSize[val] > 0) {
        acc[val] = `${buttonSize[val]}px`;
      }

      return acc;
    }, {}))()
  };
  return React.createElement(BaseButton, _extends({
    type: "button",
    ref: ref,
    template: template,
    onClick: e => {
      setButtonSize({
        width: ref.current.offsetWidth,
        height: ref.current.offsetHeight
      });
      onClick(e);
    },
    disabled: showLoader || disabled // eslint-disable-next-line react/jsx-props-no-spreading

  }, accumulatedProps), showLoader ? React.createElement(LoaderContainer, null, React.createElement(Loader, {
    width: `calc(${accumulatedProps.height} / 2)`,
    height: `calc(${accumulatedProps.height} / 2)`,
    borderWidth: "5px",
    marginTop: "0"
  })) : children);
};
Button.propTypes = {
  children: PropTypes.node.isRequired,
  showLoader: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  template: PropTypes.shape()
};
Button.defaultProps = {
  showLoader: false,
  disabled: false,
  template: null,
  onClick: () => {}
};